import { Alert, Stack, Text } from "@sembark-travel/ui/base"
import { Helmet } from "react-helmet-async"
import { SchedulesListView } from "./../../../CabScheduling"
import { generatePath } from "../../../router-utils"
import { Link } from "@sembark-travel/ui/router"

export default function SchedulesListModule() {
	return (
		<>
			<Helmet>
				<title>Cab Schedules</title>
			</Helmet>
			<Alert status="warning" title="Deprecated" rounded="none">
				<Stack gap="1">
					<Text>
						Cab scheduling have been moved to{" "}
						<Link
							to={generatePath("/operational-bookings")}
							fontWeight="semibold"
							textDecoration={"underline"}
						>
							Operational Bookings
						</Link>
						. This section will be removed in upcoming updates.
					</Text>
					<Text>Please provide your feedback in our support channel.</Text>
				</Stack>
			</Alert>
			<SchedulesListView />
		</>
	)
}
